import React from "react";
import {
  BenefitsInfo,
  ScreenWrapper,
  SummaryBenefits,
} from "../../components/Screens";
import { AttachMoney, AvTimer, Eco } from "@material-ui/icons";
import { useSelector } from "react-redux";
import {
  getEcoBenefits,
  getFundsBenefits,
  getSummaryBenefits,
  getTimeBenefits,
} from "../../reducers/benefits/selectors";
import content from "../../content";
import styled from "styled-components";
import isIframeMode from "../../utils/isIframeMode";

const Label = styled.div<{ iframeMode?: boolean }>`
  color: white;
  font-size: 1.7em;
  font-weight: 600;
  margin-bottom: 50px;
  text-align: ${({ iframeMode }) => (iframeMode ? "center" : "left")};
`;

const Columns = styled.div<{ iframeMode?: boolean }>`
  display: grid;
  grid-template-columns: ${({ iframeMode }) =>
    iframeMode ? "repeat(3, minmax(0, 1fr))" : "1fr"};
  gap: 30px;

  @media (max-width: 1100px) {
    grid-template-columns: 1fr;
  }
`;

function SummaryBenefitsScreen() {
  const summaryBenefits = useSelector(getSummaryBenefits);
  const ecoBenefits = useSelector(getEcoBenefits);
  const fundsBenefits = useSelector(getFundsBenefits);
  const timeBenefits = useSelector(getTimeBenefits);
  const iframeMode = isIframeMode();

  return (
    <ScreenWrapper
      style={{
        height: "unset",
        padding: iframeMode ? "48px 6%" : undefined,
      }}
    >
      {summaryBenefits.length === 0 ? (
        <BenefitsInfo iframeMode={iframeMode} />
      ) : (
        <>
          <Label iframeMode={iframeMode}>
            {content.getValue("benefits_real_pros")}
          </Label>
          <Columns iframeMode={iframeMode}>
            <SummaryBenefits
              key={"summaryBenefits1"}
              iframeMode={iframeMode}
              icon={<AttachMoney />}
              label={content.getValue("benefits_finances")}
              list={fundsBenefits}
            />
            <SummaryBenefits
              key={"summaryBenefits2"}
              iframeMode={iframeMode}
              icon={<AvTimer />}
              label={content.getValue("benefits_time")}
              list={timeBenefits}
            />
            <SummaryBenefits
              key={"summaryBenefits3"}
              iframeMode={iframeMode}
              icon={<Eco />}
              label={content.getValue("benefits_env")}
              list={ecoBenefits}
            />
          </Columns>
        </>
      )}
    </ScreenWrapper>
  );
}

export default SummaryBenefitsScreen;
